module.exports = __webpack_public_path__ + "media/images/icons/twotone/phone-4b2e0c4a12327e5169baafaac1c87def.svg";